/**
 * src/lib/wakeServices.ts
 *
 * cost-audit follow-up (seq #29788, #29874, #29900) — pre-warms
 * adk-relay/relay-planner so a cold start happens concurrently
 * with whatever the user is already doing, instead of on their first real
 * request to one of those services. No user-visible or user-triggerable
 * control exists for this (unlike an actual deploy action, which must
 * never be exposed this way) — App.tsx wires this to fire on initial auth
 * and on any click anywhere in the app, throttled here so a burst of
 * clicks doesn't produce a burst of requests.
 *
 * There's no separate "check if awake" step: hitting /health IS the check
 * — cheap/fast if the service is already warm, triggers its cold start if
 * it isn't. Server-side (server/api/wakeServices.ts) is where the actual
 * target URLs live; the client never knows what it's waking.
 */
import { getAuthHeader } from "./auth";

export const WAKE_COOLDOWN_MS = 5 * 60 * 1000;

let lastWakeAttempt = 0;

/** Returns true if it actually fired a request, false if throttled. */
export function maybeWakeServices(now: number = Date.now()): boolean {
  if (now - lastWakeAttempt < WAKE_COOLDOWN_MS) return false;
  lastWakeAttempt = now;
  getAuthHeader()
    .then(headers => fetch("/api/relay/wake-services", { method: "POST", headers }))
    .catch(err => console.warn("[wake-services] pre-warm failed (non-fatal):", err));
  return true;
}

/** Test-only — resets the module-level throttle between test cases. */
export function _resetWakeServicesThrottleForTests(): void {
  lastWakeAttempt = 0;
}
